module.exports = __webpack_public_path__ + "static/media/mobile_app_development.69f87504.svg";